import { Helmet } from "react-helmet-async";

const SITE_NAME = "LawFusion.AI";
const DEFAULT_DESCRIPTION =
  "AI-powered legal analysis platform using multiple AI models to stress-test your legal arguments. Built for solo practitioners and small law firms.";
const BASE_URL = "https://lawfusion.ai";

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "",
  noIndex = false,
}) => {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Multiple AIs. Stronger Arguments.`;
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {/* Always emitted, not just when noIndex. index.html no longer ships a
          static robots tag, and Helmet appends rather than replaces — so a
          static default plus this one produced two conflicting tags on every
          noIndex page. */}
      <meta
        name="robots"
        content={noIndex ? "noindex, nofollow" : "index, follow"}
      />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
